import { useQuery, useQueryClient } from "@tanstack/react-query";
import type { Me } from "@impuls/shared";
import { api } from "./api";

export const ME_KEY = ["me"] as const;

export function useMe() {
  return useQuery({ queryKey: ME_KEY, queryFn: () => api.get<Me>("/api/me"), staleTime: 60_000, retry: 1 });
}

export function useLogout() {
  const qc = useQueryClient();
  return async () => {
    await api.post("/api/logout").catch(() => {});
    qc.clear();
    await qc.invalidateQueries({ queryKey: ME_KEY });
  };
}
